import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BASE_URI, config } from 'app/app.config';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  public BASE_URL = BASE_URI.URL;

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Get feedback list with pagination and filters
   * @param payLoad - Object containing offset, limit, search, sort parameters
   */
  getFeedbackList(payLoad: any) {
    const Params = this.preHttpParams(payLoad);
    return this.http.get(`${this.BASE_URL}/getAIFeedback?offset=${payLoad.offset}&limit=${payLoad.limit}&search=${payLoad.search}&user_id=${payLoad.user_id}`);
  }


  /**
   * Build HTTP params from payload object
   * @param payLoad - Object with key-value pairs
   */
  preHttpParams(payLoad: any) {
    let Params = new HttpParams();
    for (const key in payLoad) {
      if (key && (payLoad[key] || payLoad[key] === 0 || payLoad[key] === '')) {
        Params = Params.append(key, payLoad[key]);
      }
    }
    return Params;
  }
}
